// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f5c838c1","239":"ea94a687","455":"7134f649"}[chunkId] + ".chunk.js";
};